<template>
  <div>
    <CDataTable
      class="mb-0 table-outline"
      hover
      :items="couponList"
      :fields="tableFields"
      head-color="light"
      table-filter
      column-filter
      itemps-per-page-select
      :items-per-page="10"
      sorter
      :sorterValue.sync="tableSorter"
      pagination
      size="sm"
      v-if="loading"
    >
      <td slot="name" slot-scope="{ item }">
        <span class="ml-2 text-left">{{ item.name }}</span>
      </td>
      <td slot="status" slot-scope="{ item }" class="text-center">
        <span>{{ item.status | statusName }}</span>
      </td> 
      <td slot="description" slot-scope="{ item }" class="text-center">
        <span class="pointer text-info" v-c-tooltip.hover="{content: item.description}"
        color="secondary">{{ item.description | wordLimit(15, "...") }}</span>
      </td>
      <td
        slot="activatedSince"
        slot-scope="{ item }"
        class="text-center"
        v-if="couponDiscounted"
      >
        <span>{{ item.activatedSince | formatDate }}</span>
      </td>
      <td
        slot="activatedBefore"
        slot-scope="{ item }"
        class="text-center"
        v-if="couponDiscounted"
      >
        <span>{{ item.activatedBefore | formatDate }}</span>
      </td>
      <td slot="validateSince" slot-scope="{ item }" class="text-center">
        <span>{{ item.validateSince | formatDate }}</span>
      </td>
      <td slot="validateUntil" slot-scope="{ item }" class="text-center">
        {{ item.validateUntil | formatDate }}
      </td>
      <template #show_details="{ item }">
        <td class="py-2 text-center">
          <CButton
            color="info"
            class="mx-2"
            square
            size="sm"
            @click="openCouponCheckDialog(item.id)"
            >確認</CButton
          >
        </td>
      </template>
      <template #show_edit="{ item }">
        <td class="py-2 text-center">
          <CButton
            color="success"
            class="mx-2"
            square
            size="sm"
            @click="openCouponEditDialog(item.id)"
            :disabled="!canEdit(item)"
            >編集</CButton
          >
        </td>
      </template>
      <template #show_status="{ item }">
        <td class="py-2 text-center">
          <CButton
            color="success"
            class="mx-2"
            square
            size="sm"
            @click="openChangeStatusDialog(item.id)"
            >更新</CButton
          >
        </td>
      </template>
      <template #show_delete="{ item }">
        <td class="py-2 text-center">
          <CButton
            color="danger"
            class="mx-2"
            square
            size="sm"
            @click="openDeleteDialog(item.id)"
            :disabled="!canEdit(item)"
            >削除</CButton
          >
        </td>
      </template>
      <template #assignCoupon="{ item }">
        <td class="py-2 text-center">
          <CButton
            color="warning"
            class="mx-2"
            square
            size="sm"
            @click="openCouponAssignDialog(item.id)"
            >割当</CButton
          >
        </td>
      </template>
      <template #acquiredCoupon="{ item }">
        <td class="py-2 text-center">
          <CButton
            color="primary"
            class="mx-2"
            square
            size="sm"
            @click="openCouponAcquiredDialog(item.id)"
            >会員リスト</CButton
          >
        </td>
      </template>
    </CDataTable>
    <CAlert v-if="!loading" color="danger" class="mt-3 text-center"
      >現在、利用可能なクーポンはありません。</CAlert
    >
    <CAlert color="info" class="mt-3">
      クーポンの編集/削除は、ステータスが「0:無効、1:掲載準備中」のときに行えます。
    </CAlert>
    <!-- For Coupon use ↓↓↓ -->
    <CModal
      color="dark"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="activateModel"
    >
      <div class="coupon-info">
        <!-- <p>getCoupon: {{ getCoupon }}</p> -->
        <CForm class="member-info modal-form">
          <CRow>
            <CCol lg="6">
              <CInput
                label="クーポンID"
                plaintext
                horizontal
                v-model="couponId"
              />
            </CCol>
            <CCol lg="6">
              <CInput
                label="利用開始日"
                plaintext
                horizontal
                v-model="getCoupon.validateSince"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol lg="6">
              <CInput
                label="クーポン名"
                plaintext
                horizontal
                v-model="getCoupon.name"
              />
            </CCol>
            <CCol lg="6">
              <CInput
                label="利用終了日"
                plaintext
                horizontal
                v-model="getCoupon.validateUntil"
              />
            </CCol>
          </CRow>
          <CRow> </CRow>
          <CRow>
            <CCol lg="6">
              <h5 class="sub-title my-3">オプション</h5>
            </CCol>
          </CRow>
          <CRow>
            <CCol lg="6">
              <strong>集計</strong> | <strong>全在庫合計</strong>:
              {{ totalActivations }} | <strong>獲得済み合計</strong>:
              {{ totalActivated }} | <strong>残り在庫合計</strong>:
              {{ totalInventory }}
            </CCol>
          </CRow>

          <CRow>
            <CCol class="">
              <div class="tbl-content">
                <table class="table responsive-table table-sm mb-0">
                  <thead>
                    <tr>
                      <th class="sticky-top" width="30">No.</th>
                      <th class="sticky-top">オプション名</th>
                      <th class="sticky-top">割引種別</th>
                      <th class="sticky-top">割引直</th>
                      <th class="sticky-top">全在庫数</th>
                      <th class="sticky-top">残り在庫</th>
                      <!-- <th width="80" class="text-right">
                        獲得数<span class="use_sum">{{
                          sumOfTransactions
                        }}</span>
                      </th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="option in getCoupon.options" :key="option.order">
                      <td>
                        {{ option.order }}
                      </td>
                      <td>{{ option.name }}</td>
                      <td>{{ option.type }}</td>
                      <td>{{ option.value }}</td>
                      <td>{{ option.activations }}</td>
                      <td>{{ getInventory(option) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CCol>
          </CRow>
        </CForm>
      </div>
      <template #header> クーポン在庫確認 </template>
      <template #footer>
        <CButton @click="cancelCouponN()" color="secondary"
          ><i class="icon cil-x"></i>閉じる</CButton
        >
      </template>
    </CModal>
    <!-- end Coupon use  -->

    <!-- For Coupon Edit ↓↓↓  -->
    <CModal
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="editingModal"
    >
      <div class="coupon-info">
        <!-- <p>Edit Modal: {{ getCoupon }}</p> -->
        <CForm class="member-info modal-form">
          <CRow>
            <CCol lg="6">
              <CInput label="SKU" horizontal v-model="getCoupon.sku" />
            </CCol>
          </CRow>

          <CRow>
            <CCol lg="6">
              <CInput label="クーポン名" horizontal v-model="getCoupon.name" />
            </CCol>
            <CCol lg="6">
              <CTextarea
                rows="1"
                label="クーポン説明"
                horizontal
                v-model="getCoupon.description"
              />
            </CCol>
          </CRow>

          <CRow>
            <CCol lg="6">
              <!-- TODO: activatedBeforeは誤り -->
              <CInput
                label="掲載開始日"
                type="date"
                min="1900-01-01"
                max="2100-12-31"
                horizontal
                v-model="getCoupon.activatedSince"
              />
            </CCol>
            <CCol lg="6">
              <CInput
                label="掲載終了日"
                type="date"
                min="1900-01-01"
                max="2100-12-31"
                horizontal
                v-model="getCoupon.activatedBefore"
              />
            </CCol>
          </CRow>

          <CRow>
            <CCol lg="6">
              <CInput
                label="利用開始日"
                type="date"
                min="1900-01-01"
                max="2100-12-31"
                horizontal
                v-model="getCoupon.validateSince"
              />
            </CCol>
            <CCol lg="6">
              <CInput
                label="利用終了日"
                type="date"
                min="1900-01-01"
                max="2100-12-31"
                horizontal
                v-model="getCoupon.validateUntil"
              />
            </CCol>
          </CRow>

          <CRow>
            <CCol lg="6">
              <!-- <CInput label="クーポン画像" horizontal /> -->
              <CInput
                label="クーポン画像"
                description="※開発中のファイル指定> 10/31バナー:/banner/coupon_banner_1031.jpg 11/1バナー:/banner/coupon_banner_1101.jpg"
                horizontal
                v-model="getCoupon.picture"
              />
            </CCol>
            <CCol lg="6" class="checkbok_d">
              <div class="form-group form-row">
                <label class="col-form-label col-sm-3">複数獲得可否</label>
                <div class="col-sm-9 pl-0">
                  <!-- <CInputCheckbox horizontal v-model="getCoupon.multiple" /> -->
                  <CInputCheckbox
                    horizontal
                    :checked.sync="getCoupon.multiple"
                  />
                </div>
              </div>
            </CCol>
            <!-- <CCol lg="6" class="checkbok_d">
              <div class="form-row">
                <label class="col-form-label col-sm-3">クーポン有効無効</label>
                <div class="col-sm-9 pl-0">
                  <CInputCheckbox
                    label=""
                    horizontal
                    :checked.sync="getCoupon.enabled"
                  />
                </div>
              </div>
            </CCol> -->
          </CRow>
          <!-- coupon option ↓↓↓ -->
          <CRow
            class="coupon-opion mx-5 my-4 px-3 pb-3 bg-soft card"
            v-for="(option, n) in getCoupon.options"
            :key="option.order"
          >
            <CCol>
              <CRow>
                <CCol>
                  <h4 class="sub-title">オプション: {{ ++n }}</h4>
                </CCol>
                <CCol v-if="n > 1">
                  <!-- TODO: 右寄せにする -->
                  <CButton color="dark" @click="deleteOption(n - 1)">
                    <i class="icon cil-minus"></i> オプション削除
                  </CButton>
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CInput label="SKU" horizontal v-model="option.sku" />
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CInput
                    label="オプション名"
                    horizontal
                    v-model="option.name"
                  />
                </CCol>
                <CCol lg="6">
                  <CTextarea
                    label="オプション説明"
                    type="textare"
                    horizontal
                    rows="1"
                    v-model="option.description"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6" class="radiio_section checkbok_d">
                  <div class="form-group form-row">
                    <label class="col-form-label col-sm-3">割引種別</label>
                    <div class="col-sm-9 pl-0">
                      <span class="form-check-inline">
                        <input
                          type="radio"
                          :name="'discoundtAmount' + n"
                          value="2"
                          v-model="option.type"
                        />
                        <label
                          class="form-check-label mr-4"
                          :for="'discoundtAmount' + n"
                          >割引金額</label
                        >

                        <input
                          type="radio"
                          :name="'discountRate' + n"
                          value="1"
                          v-model="option.type"
                        />
                        <label
                          class="form-check-label"
                          :for="'discountRate' + n"
                          >割引率</label
                        >
                      </span>
                    </div>
                  </div>
                  <!-- {{ option.type }} -->
                </CCol>

                <CCol lg="6">
                  <CInput label="割引値" horizontal v-model="option.value" />
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CInput
                    label="利用回数制限"
                    horizontal
                    v-model="option.count"
                  />
                </CCol>

                <CCol lg="6">
                  <CInput
                    label="最低利用金額"
                    horizontal
                    v-model="option.minPrice"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <CInput
                    label="全在庫数"
                    horizontal
                    v-model="option.activations"
                  />
                </CCol>

                <!-- <CCol lg="6">
                  <CInput
                    label="獲得数"
                    horizontal
                    v-model="option.activated"
                  />
                </CCol> -->
              </CRow>
            </CCol>
          </CRow>
          <CRow>
            <CCol lg="6" class="px-5">
              <CButton color="dark" @click="addNewOption()"
                ><i class="icon cil-plus"></i> オプション追加</CButton
              >
            </CCol>
          </CRow>
        </CForm>
      </div>
      <template #header> クーポン編集 </template>
      <template #footer>
        <CButton @click="cancelCoupon()" color="secondary"> キャンセル</CButton>
        <CButton @click="saveEditedCoupon()" color="success"> 保存</CButton>
      </template>
    </CModal>
    <!-- End Coupon Edit ↑↑↑ -->
    <!-- For Coupon Assign ↓↓↓ -->
    <CModal
      color="dark"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="assignCouponModal"
    >
      <div class="coupon-info">
        <CRow>
          <CCol lg="6">
            <p>割り当てる会員を検索します</p>
          </CCol>
        </CRow>

        <CForm class="search-filter">
          <CRow class="mb-2">
            <CCol sm="7" lg="5">
              <div class="form-group form-row m-0">
                <label class="col-form-label col-sm-3">カードID</label>
                <div class="col-sm-9">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="カードIDを入力（部分一致）"
                    v-model="ConvertId"
                    @keydown.enter="onSearchQuery($event, 'cardId')"
                  />
                  <small class="form-text text-muted w-100"
                    >カードIDには5桁以上の値を入力してください</small
                  >
                </div>
              </div>
            </CCol>

            <CCol sm="3" lg="2">
              <CButton
                @click="getSearchQuery('cardId')"
                class="info-button w-100"
                :disabled="$v.query.cardId.$invalid"
              >
                <i class="icon cil-search"></i> 検索
              </CButton>
              <!-- 検索 -->
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="7" lg="5">
              <CInput
                label="氏名"
                class="search-input"
                placeholder="氏名または氏名(カナ)を入力して検索してください（部分一致）"
                horizontal
                v-model="query.name"
                @keydown.enter="onSearchQuery($event, 'name')"
              />
            </CCol>
            <CCol sm="3" lg="2">
              <CButton
                @click="getSearchQuery('name')"
                class="info-button w-100"
                :disabled="!query.name"
              >
                <i class="icon cil-search"></i> 検索
              </CButton>
            </CCol>
          </CRow>
        </CForm>
        <!-- <CCollapse :show="collapse" :duration="200"> -->
        <CCollapse :show="true" :duration="200">
          <CCardBody>
            <div class="user-info-table">
              <dl class="row">
                <dt class="col-sm-12">
                  <h4 class="sub-title">会員一覧</h4>
                </dt>
              </dl>
              <CDataTable
                class="mb-0 table-outline"
                hover
                size="sm"
                :items="user"
                :fields="userTableFields"
                head-color="light"
                column-filter
                sorter
                itemps-per-page-select
                :items-per-page="100"
                pagination
                v-if="!loading"
              >
                <!-- sorter
                :sorterValue.sync="tableSorter" -->

                <td slot="cardId" class="text-left" slot-scope="{ item }">
                  <strong>{{ item.cardId }}</strong>
                </td>
                <td slot="familyName" slot-scope="{ item }">
                  <strong>{{ item.familyName }}</strong>
                </td>
                <td slot="givenName" slot-scope="{ item }">
                  <strong>{{ item.givenName }}</strong>
                </td>
                <!-- <td slot="lastName" slot-scope="{ item }">
                    <strong>{{ item.lastName }}</strong>
                  </td>
                  <td slot="firstName" slot-scope="{ item }">
                    <strong>{{ item.firstName }}</strong>
                  </td> -->
                <td slot="email" slot-scope="{ item }">
                  <strong>{{ item.email }}</strong>
                </td>
                <td slot="mobile" slot-scope="{ item }">
                  <strong>{{ item.mobile }}</strong>
                </td>
                <template #profile_edit="{ item }">
                  <td class="py-2 text-center">
                    <CButton
                      color="info"
                      square
                      block
                      size="sm"
                      @click="goToCopuonActivatePage(item.name)"
                      >割り当てる</CButton
                    >
                  </td>
                </template>
              </CDataTable>
            </div>
          </CCardBody>
        </CCollapse>
      </div>
      <template #header>会員に割引プランを割り当てる</template>
      <template #footer>
        <CButton @click="cancelCouponAssign()" color="danger"
          ><i class="icon cil-x"></i>閉じる</CButton
        >
      </template>
    </CModal>
    <!-- end Coupon Assign use  -->
    <!-- Complete Dialog ↓↓↓ -->
    <CModal
      color="success"
      size="lg"
      :closeOnBackdrop="false"
      :show.sync="completeModal"
    >
      <strong>{{ responseMsg }}</strong>
      <template #header> クーポン更新完了 </template>
      <template #footer>
        <CButton @click="completeModal = false" color="secondary"
          >閉じる</CButton
        >
      </template>
    </CModal>
    <!-- Complete Dialog ↑↑↑ -->

    <!-- Error Dialog start  -->
    <CModal
      color="danger"
      size="lg"
      :closeOnBackdrop="false"
      :show.sync="errorDialog"
    >
      <strong>{{ responseMsg }}</strong>
      <template #header> クーポン更新失敗 </template>
      <template #footer>
        <CButton @click="errorDialog = false" color="secondary" class="px-3"
          >閉じる</CButton
        >
      </template>
    </CModal>
    <!-- Error Dialog end  -->

    <!-- Change coupon status modal start -->
    <CModal
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="changeStatusModal"
    >
      <div class="coupon-info">
        <!-- <p>Edit Modal: {{ getCoupon }}</p> -->
        <CForm class="member-info modal-form">
          <CRow>
            <!-- <CCol lg="6">
              <CInput label="SKU" horizontal v-model="getCoupon.sku" />
            </CCol> -->
            <CCol lg="6">
              <CInput
                label="クーポン名"
                plaintext
                horizontal
                v-model="getCoupon.name"
              />
            </CCol>
            <CCol lg="6">
              <CTextarea
                rows="1"
                label="クーポン説明"
                plaintext
                horizontal
                v-model="getCoupon.description"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol lg="6">
              <!-- TODO: activatedBeforeは誤り -->
              <CInput
                label="掲載開始日"
                type="date"
                min="1900-01-01"
                max="2100-12-31"
                horizontal
                plaintext
                v-model="getCoupon.activatedSince"
              />
            </CCol>
            <CCol lg="6">
              <CInput
                label="掲載終了日"
                type="date"
                min="1900-01-01"
                max="2100-12-31"
                horizontal
                plaintext
                v-model="getCoupon.activatedBefore"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol lg="6">
              <CInput
                label="利用開始日"
                type="date"
                min="1900-01-01"
                max="2100-12-31"
                horizontal
                plaintext
                v-model="getCoupon.validateSince"
              />
            </CCol>
            <CCol lg="6">
              <CInput
                label="利用終了日"
                type="date"
                min="1900-01-01"
                max="2100-12-31"
                horizontal
                plaintext
                v-model="getCoupon.validateUntil"
              />
            </CCol>

            <CCol lg="6" class="checkbok_d">
              <div class="form-row">
                <label class="col-form-label col-sm-3">ステータス</label>
                <div class="col-sm-9 pl-0">
                  <CSelect
                    horizontal
                    :value.sync="getCoupon.status"
                    :options="couponStatus"
                    description="※「10:掲載中」にした場合、会員がクーポン獲得可能となります。"
                  />
                </div>
              </div>
            </CCol>
          </CRow>
        </CForm>
      </div>
      <template #header> ステータス更新 </template>
      <template #footer>
        <CButton @click="cancelCoupon()" color="secondary"> キャンセル</CButton>
        <CButton @click="putCouponStatus()" color="success"> 更新</CButton>
      </template>
    </CModal>
    <!-- Change coupon status modal end -->

    <!-- Delete coupon modal start -->
    <CModal
      color="dark"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="deleteModal"
    >
      <div class="coupon-info">
        <!-- <p>Edit Modal: {{ getCoupon }}</p> -->
        <CForm class="member-info modal-form">
          <CRow>
            <CCol lg="6">
              <CInput
                label="クーポン名"
                plaintext
                horizontal
                v-model="getCoupon.name"
              />
            </CCol>
            <CCol lg="6">
              <CTextarea
                rows="1"
                label="クーポン説明"
                plaintext
                horizontal
                v-model="getCoupon.description"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol lg="6">
              <!-- TODO: activatedBeforeは誤り -->
              <CInput
                label="掲載開始日"
                type="date"
                min="1900-01-01"
                max="2100-12-31"
                horizontal
                plaintext
                v-model="getCoupon.activatedSince"
              />
            </CCol>
            <CCol lg="6">
              <CInput
                label="掲載終了日"
                type="date"
                min="1900-01-01"
                max="2100-12-31"
                horizontal
                plaintext
                v-model="getCoupon.activatedBefore"
              />
            </CCol>
          </CRow>
          <CRow>
            <CCol lg="6">
              <CInput
                label="利用開始日"
                type="date"
                min="1900-01-01"
                max="2100-12-31"
                horizontal
                plaintext
                v-model="getCoupon.validateSince"
              />
            </CCol>
            <CCol lg="6">
              <CInput
                label="利用終了日"
                type="date"
                min="1900-01-01"
                max="2100-12-31"
                horizontal
                plaintext
                v-model="getCoupon.validateUntil"
              />
            </CCol>
          </CRow>
        </CForm>
      </div>
      <template #header> クーポン削除 </template>
      <template #footer>
        <CButton @click="cancelCoupon()" color="secondary"> キャンセル</CButton>
        <CButton @click="onDeleteCouponClick()" color="danger"
          ><i class="icon cil-trash"></i> 削除</CButton
        >
      </template>
    </CModal>
    <!-- Delete coupon modal end -->

    <!-- Complete Dialog ↓↓↓ -->
    <CModal
      color="danger"
      size="lg"
      :closeOnBackdrop="false"
      :show.sync="deleteConfirmModal"
    >
      <strong>{{ responseMsg }}</strong>
      <template #header> クーポン削除確認 </template>
      <template #footer>
        <CButton @click="deleteConfirmModal = false" color="secondary"
          >キャンセル</CButton
        >
        <CButton @click="onRunDeleteCouponClick()" color="danger">
          <i class="icon cil-trash"></i> 削除実行
        </CButton>
      </template>
    </CModal>
    <!-- Complete Dialog ↑↑↑ -->
     
  </div>
</template>

<script>
// import Vue from 'vue'
import axios from "axios";
import { required, numeric, minLength } from "vuelidate/lib/validators";

const COUPON_STATUS = {
  INVALID: 0, // 無効
  READY: 1, // 掲載準備中
  BEING_PUBLISHED: 10, // 掲載中
  BEING_PUBLISHED_STOP: 15, // 掲載一時停止
  BEING_PUBLISHED_ENDED: 20, // 掲載完了
  ENDED: 99, // イベント終了
  ABOLISHED: 100, // 削除(リストに表示しない)
};

export default {
  name: "CouponsListTable",
  props: {
    CouponStatus: {
      type: String,
    },
    StatusType: {
      type: String,
    },
  },
  data() {
    return {
       
      editingModal: false,
      completeModal: false,
      errorDialog: false,
      activateModel: false,
      changeStatusModal: false,
      deleteModal: false,
      deleteConfirmModal: false,
      assignCouponModal: false,
      couponDiscounted: true,
      collapse: false,
      couponStatus: [
        {
          value: COUPON_STATUS.INVALID,
          label: COUPON_STATUS.INVALID + ": 無効",
        },
        {
          value: COUPON_STATUS.READY,
          label: COUPON_STATUS.READY + ": 掲載準備中",
        },
        {
          value: COUPON_STATUS.BEING_PUBLISHED,
          label: COUPON_STATUS.BEING_PUBLISHED + ": 掲載中",
        },
        {
          value: COUPON_STATUS.BEING_PUBLISHED_STOP,
          label: COUPON_STATUS.BEING_PUBLISHED_STOP + ": 掲載一時停止",
        },
        // { value: COUPON_STATUS.BEING_PUBLISHED_ENDED, label: COUPON_STATUS.BEING_PUBLISHED_ENDED + ': 掲載完了' },
        // { value: COUPON_STATUS.ENDED,                 label: COUPON_STATUS.ENDED + ': イベント終了' },
      ],
      totalActivations: 0,
      totalActivated: 0,
      totalInventory: 0,

      loading: false,
      responseMsg: "",
      couponId: "",
      userCardId: "",
      getCoupon: {
        name: "",
        description: "",
        options: [
          //delete
          {
            name: "",
            type: 2,

            reduction: 0,
          },
        ],
      },
      couponG: "",
      couponOptionG: "",
      couponActivations: [],
      isToggled: "",
      totalsum: "",
      selectedOption: false,
      couponList: [
        {
          id: "",
          sku: "",
          name: "",
          description: "",
          picture: null,
          options: [
            {
              id: "",
              sku: "",
              name: "",
              reduction: 0,
            },
          ],
          activatedBefore: "",
          validateSince: "",
          validateUntil: "",
          multiple: Boolean,
        },
      ],

      tableFields: [
        { key: "name", label: "クーポン名", _classes: "text-center bg-light" },
        { key: "status", label: "ステータス", _classes: "text-center bg-light" },
        { key: "description", label: "説明", _classes: "text-center bg-light" },
        { key: "activatedSince", label: "掲載開始日", _classes: "text-center bg-light" },
        {
          key: "activatedBefore",
          label: "掲載終了日",
          _classes: "text-center bg-light",
        },
        { key: "validateSince", label: "利用開始日", _classes: "text-center bg-light" },
        { key: "validateUntil", label: "利用終了日", _classes: "text-center bg-light" },

        {
          key: "show_details",
          _classes: "text-center bg-light",
          label: "在庫",
          _style: "",
          sorter: false,
          filter: false,
        },
        {
          key: "show_edit",
          _classes: "text-center bg-light",
          label: "編集",
          _style: "",
          sorter: false,
          filter: false,
        },
        {
          key: "show_status",
          _classes: "text-center bg-light",
          label: "ステータス更新",
          _style: "",
          sorter: false,
          filter: false,
        },
        {
          key: "show_delete",
          _classes: "text-center bg-light",
          label: "削除",
          _style: "",
          sorter: false,
          filter: false,
        },
        {
          key: "assignCoupon",
          _classes: "text-center bg-light",
          label: "割当",
          _style: "",
          sorter: false,
          filter: false,
        },
        {
          key: "acquiredCoupon",
          _classes: "text-center bg-light",
          label: "会員リスト",
          _style: "",
          sorter: false,
          filter: false,
        },
      ],
      targetStatus: "",
      query: {
        cardId: "",
        username: "",
        name: "",
        email: "",
        phone: "",
        zipcode: "",
        address: "",
      },
      user: [
        {
          familyName: "",
          givenName: "",
          firstName: "",
          lastName: "",
          gender: "",
          birth: "",
          email: "",
          mobile: "",
          cardId: "",
        },
      ],
      userTableFields: [
        { key: "cardId", label: "会員ID", _classes: "text-center" },
        { key: "familyName", label: "氏", _classes: "text-center" },
        { key: "givenName", label: "名", _classes: "text-center" },
        // { key: "firstName", label: "氏(カナ)", _classes: "text-center" }, // TODO: 本来逆
        // { key: "lastName", label: "名(カナ)", _classes: "text-center" }, // TODO: 本来逆
        { key: "email", label: "Eメールアドレス", _classes: "text-center" },
        { key: "mobile", label: "	電話番号", _classes: "text-center" },
        // { key: "電話番号", label: "提出時間", _classes: "text-right" },
        {
          key: "profile_edit",
          label: "会員情報",
          sorter: false,
          filter: false,
          _classes: "text-center",
        },
      ],
      userCount: 0,
    };
  },
  validations: {
    userCardId: { required, numeric, minLength: minLength(16) },
    query: { cardId: { required, minLength: minLength(5) } },
  },
  computed: {
    sumOfTransactions() {
      var sum = 0;
      this.getCoupon.options.forEach((e) => {
        sum += e.reduction == null ? 0 : parseFloat(e.reduction);
      });
      return sum;
    },
    ConvertId: {
      get() {
        return this.query.cardId;
      },
      set(value) {
        var conv = value.replace(/[\uff01-\uff5e]/g, function (ch) {
          return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
        });
        this.query.cardId = conv;
      },
    },
  },

  methods: {
    onSearchQuery: function (event, value) {
      // 日本語入力中のEnterキー操作は無効
      if (event.keyCode !== 13) return;
      switch (value) {
        case "cardId":
          if (!this.query.cardId) return;
          break;
        case "username":
          if (!this.query.username) return;
          break;
        case "name":
          if (!this.query.name) return;
          break;
        default:
          return;
      }
      this.getSearchQuery(value);
    },
    getSearchQuery: function (value) {
      var urlRequest;
      switch (value) {
        case "cardId":
          urlRequest = "/rest/users?card=" + this.query.cardId;
          break;
        case "username":
          urlRequest = "/rest/users/" + this.query.username;
          break;
        case "name":
          urlRequest = "/rest/users?name=" + this.query.name;
          break;
        default:
          urlRequest = "error";
      }

      this.loading = true;

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          if (value == "username") {
            // 会員リスト表示のため、JSONデータをthis.userにpush
            this.user = [];
            this.user.push(resp.data);
          } else {
            this.user = resp.data;
          }

          // this.user = resp.data;
          console.log("User Data:" + JSON.stringify(this.user));
          // this.searchResult = "";
          this.loading = false;
          this.collapse = true;

          this.user == ""
            ? ((this.collapse = false), (this.notFound = true))
            : ((this.collapse = true), (this.notFound = false));
        })
        .catch((err) => {
          console.log(err);
          this.notFound = true;
           
          // alert(this.PassError)
          // if (err.response.status == 404) {
          //   this.errorModal = true;
          //   this.errors = "ログインのセッションが切れましたので、再度ログインしてください";
          // }
          // this.searchResult = "会員が見つかりませんでした。";
          this.loading = false;
          this.collapse = false;
        });
    },
    getCouponList: function () {
      var urlRequest = "/rest/coupon?status=" + this.CouponStatus;
      this.loading = false;
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.couponList = resp.data;
          this.loading = true;
          console.log("Data:" + JSON.stringify(this.couponList));
        })
        .catch((err) => {
           

          console.log(err);
          this.loading = false;
        });
    },

    openCouponEditDialog: function (couponId) {
      this.editingModal = true;
      this.sortCouponOptions(couponId);
      this.editRole = true; // Delete me after fix status rule
    },
    openCouponCheckDialog: function (couponId) {
      this.activateModel = true;
      // this.sortCouponOptions(couponId);
      this.sumOptions(couponId);
      this.couponId = couponId;
    },

    openChangeStatusDialog: function (couponId) {
      this.changeStatusModal = true;
      this.sortCouponOptions(couponId);
      this.couponId = couponId;
    },

    openDeleteDialog: function (couponId) {
      this.deleteModal = true;
      this.sortCouponOptions(couponId);
      this.couponId = couponId;
    },

    sortCouponOptions(couponId) {
      var couponQ = this.couponList.find((couponQ) => couponQ.id === couponId);
      this.getCoupon = couponQ;
      // orderでsort
      this.getCoupon.options.sort((a, b) => {
        return a.order > b.order ? 1 : a.order < b.order ? -1 : 0;
      });
    },

    openCouponAssignDialog: function (couponId) {
      this.assignCouponModal = true;
      this.sortCouponOptions(couponId);
      this.couponId = couponId;
    },

    openCouponAcquiredDialog: function (couponId) {
      this.couponId = couponId;
      this.$router.push({
        name: "割引対象会員リスト",
        params: {
          couponId: this.couponId,
        },
      });
    },

    /**
     * クーポン在庫を集計
     */
    sumOptions(couponId) {
      this.sortCouponOptions(couponId);

      var totalActivations = 0;
      var totalActivated = 0;
      this.getCoupon.options.forEach((a) => {
        totalActivations += a.activations;
        totalActivated += a.activated;
      });

      this.totalActivated = totalActivated;
      this.totalActivations = totalActivations;
      this.totalInventory = totalActivations - totalActivated;
    },

    addNewOption() {
      let newObject = {
        sku: "",
        name: "",
        value: 0,
        description: "",
        type: 2,
        count: 1,
        minPrice: 0,
        activations: 100,
        activated: 0,
      };
      this.getCoupon.options.push(newObject); // Gives error.
      console.log("this.getCoupon" + JSON.stringify(this.getCoupon));
    },

    cancelCoupon: function () {
      this.couponG = "";
      this.couponOptionG = "";
      this.selectedOption = false;
      this.editingModal = false;
      this.changeStatusModal = false;
      this.deleteModal = false;
      this.isToggled = "";
      this.getCouponList();
    },
    cancelCouponN: function () {
      this.userCardId = "";
      this.activateModel = false;
      this.getCouponList();
    },
    cancelCouponAssign: function () {
      this.userCardId = "";
      this.assignCouponModal = false;
      this.getCouponList();
    },

    // Coupon Edit Submit ↓ ==================
    /**
     * クーポン更新
     */
    saveEditedCoupon: function () {
      //Add user points

      //Get current user points history
      console.log(this.getCoupon.id);
      console.log(JSON.stringify(this.getCoupon));

      // オプションの表示順を採番
      this.getCoupon.options.forEach((a, index) => (a.order = index + 1));

      var urlRequest = "/rest/coupon/" + this.getCoupon.id;
      this.loading = true;
      axios
        .put(urlRequest, this.getCoupon, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log(resp.data);
          // this.selectedOption = false;
          this.editingModal = false;
          this.completeModal = true;
          // alert("success");
          this.responseMsg = "クーポンを更新しました。";
          this.cancelCoupon();
        })
        .catch((err) => {
           

          if (err.response.status == 400) {
            this.editingModal = false;
            this.errorDialog = true;
            this.responseMsg = "クーポンの更新に失敗しました。";
          } else {
            this.responseMsg = err;
          }
        });
    },

    /**
     * クーポンステータス更新
     */
    putCouponStatus: function () {
      //Get current user points history
      console.log(this.getCoupon.id);
      console.log(JSON.stringify(this.getCoupon));
      console.log(this.getCoupon);

      var urlRequest = "/rest/coupon/" + this.getCoupon.id + "/status";
      this.loading = true;

      var body = {
        status: this.getCoupon.status,
      };

      axios
        .put(urlRequest, body, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log(resp.data);
          this.changeStatusModal = false;
          this.completeModal = true;
          this.responseMsg = "クーポンを更新しました。";
          this.cancelCoupon();
        })
        .catch((err) => {
           

          if (err.response.status == 400) {
            this.changeStatusModal = false;
            this.errorDialog = true;
            this.responseMsg = "クーポンの更新に失敗しました。";
          } else {
            this.responseMsg = err;
          }
        });
    },

    /**
     * 在庫情報
     */
    getInventory: function (option) {
      const inventory = option.activations - option.activated;
      if (inventory < 10) return "×(" + inventory + ")";
      if (inventory < 50) return "△(" + inventory + ")";
      return "○(" + inventory + ")";
    },

    deleteOption(index) {
      this.getCoupon.options.splice(index, 1);
    },

    requiredFd() {
      this.$v.userCardId.$touch();
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this));
    },

    /**
     * クーポン削除
     */
    onDeleteCouponClick() {
      this.responseMsg = "クーポンを削除します。よろしいですか？";
      this.deleteConfirmModal = true;
    },

    /**
     * クーポン削除実行
     */
    onRunDeleteCouponClick() {
      this.deleteCoupon();
    },

    deleteCoupon() {
      var urlRequest = "/rest/coupon/" + this.getCoupon.id + "/status";
      this.loading = true;

      var body = {
        status: COUPON_STATUS.ABOLISHED,
      };

      axios
        .put(urlRequest, body, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log(resp.data);
          this.deleteModal = false;
          this.deleteConfirmModal = false;
          // this.completeModal = true;
          this.responseMsg = "クーポンを削除しました。";
          this.cancelCoupon();
        })
        .catch((err) => {
           

          if (err.response.status == 400) {
            this.deleteConfirmModal = false;
            this.errorDialog = true;
            this.responseMsg = "クーポンの削除に失敗しました。";
          } else {
            this.responseMsg = err;
          }
        });
    },

    /**
     * 編集可能か判定（true:編集可能、false:編集不可）
     */
    canEdit(item) {
      if (!item) return false;

      const canEditFlag = [
        COUPON_STATUS.INVALID, // 0: 無効
        COUPON_STATUS.READY, // 1: 掲載準備中
        // COUPON_STATUS.BEING_PUBLISHED,       // 10: 掲載中
        // COUPON_STATUS.BEING_PUBLISHED_STOP,  // 15: 掲載一時停止
        // COUPON_STATUS.BEING_PUBLISHED_ENDED, // 20: 掲載完了
        // COUPON_STATUS.ENDED,                 // 99: イベント終了
        // COUPON_STATUS.ABOLISHED,             // 100: 削除(リストに表示しない)
      ].includes(item.status);

      return canEditFlag;
    },
    // copon list table property ↓↓
    changeFieldset() {
      if (this.StatusType == "discount") {
        this.couponDiscounted = false;
        this.tableFields.splice(
          this.tableFields.findIndex((item) => item.key === "activatedSince"),
          true
        );
        this.tableFields.splice(
          this.tableFields.findIndex((item) => item.key === "activatedBefore"),
          true
        );
        // this.tableFields = this.$delete(this.tableFields, function(element){return element.key == "activatedSince"}, true);
      } else {
        this.tableFields.splice(
          this.tableFields.findIndex((item) => item.key === "assignCoupon"),
          true
        );
        this.tableFields.splice(
          this.tableFields.findIndex((item) => item.key === "acquiredCoupon"),
          true
        );
        this.tableFields.splice(
          this.tableFields.findIndex((item) => item.key === "description"),
          true
        );
      }
    },
    // go to user coupon page ↓↓↓
    // go to member edit page with params
    goToCopuonActivatePage(userQName) {
      // alert(userQName+':'+ this.couponId)

      this.$router.push({
        name: "クーポン獲得",
        params: {
          userName: userQName,
          couponId: this.couponId,
          status: "active-coupon",
        },
      });
    },
  },
  beforeMount() {
    this.getCouponList();
    this.changeFieldset();
  },
};
</script>
